import { AxiosInstance, AxiosResponse } from 'axios';

type BaseMutationResponse = {
  id: string;
};

export const postReviewUploadImage = async (
  httpClient: AxiosInstance,
  payload: {
    id: string;
    version: number | string;
    files: File[];
  },
): Promise<BaseMutationResponse> => {
  const formData = new FormData();

  payload.files.forEach(file => {
    formData.append('uploadFileName', file, file.name);
  });

  const response = await httpClient.put<FormData, AxiosResponse<BaseMutationResponse>>(
    `/v1/webshop/review/upload-image/${encodeURIComponent(payload.id)}/${encodeURIComponent(
      String(payload.version),
    )}`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      transformRequest: [data => data],
    },
  );

  return response.data;
};

export const putReviewDeleteImage = async (
  httpClient: AxiosInstance,
  payload: {
    id: string;
    version: number | string;
    imageId: string;
  },
): Promise<BaseMutationResponse> => {
  const response = await httpClient.put<unknown, AxiosResponse<BaseMutationResponse>>(
    `/v1/webshop/review/delete-image/${encodeURIComponent(payload.id)}/${encodeURIComponent(
      String(payload.version),
    )}`,
    { imageId: payload.imageId },
  );

  return response.data;
};
